// extracted by mini-css-extract-plugin
module.exports = {"v360Info":"V360Info","v360InfoTitle":"V360Info-title","v360InfoText":"V360Info-text","isDesktop":"is-desktop"};